<template>
  <div class="bc__ui__select">
      <select :name="this.name" :id="this.name" v-model="optSel" @change="onChange()">
          <option v-for="(myopt, i) in this.opt" :key="myopt" :value="myopt">{{myopt}}</option>
      </select>
  </div>
</template>

<style lang="scss" scoped >

</style>


<script>
    export default {

        props: [
            'name', 'opt', 'def'
        ],

        data(){
            return {
                optSel: this.def
            };
        },

        components: {

        },

        methods: {
            onChange() {
                this.$emit('onselectchange', this.optSel);
            }
        }
    }

</script>